/** @file effectMaterial: the blended ShaderMaterial of an effect mesh (alpha or additive, no depth write). */
import { Constants } from '@babylonjs/core/Engines/constants.js';
import { ShaderMaterial } from '@babylonjs/core/Materials/shaderMaterial.js';
import type { RawTexture } from '@babylonjs/core/Materials/Textures/rawTexture.js';
import type { Scene } from '@babylonjs/core/scene.js';
import type { Profile } from '@zilo/pose3d-format/types/profile';
import { QUAD_VERTEX_GLSL } from '@zilo/pose3d-runtime-babylon/draw/quadVertexGlsl';
import { EFFECT_FRAGMENT_GLSL } from '@zilo/pose3d-runtime-babylon/effect/effectFragmentGlsl';

/** The corner vertex shader with `EFFECT_FRAGMENT_GLSL`; `ALPHA_COMBINE` or `ALPHA_ADD`, depth test LEQUAL, depth write off. */
export function effectMaterial(scene: Scene, sheet: RawTexture, blend: 'alpha' | 'add', sampling: Profile['sampling'], name: string): ShaderMaterial {
  const material = new ShaderMaterial(name, scene, { vertexSource: QUAD_VERTEX_GLSL, fragmentSource: EFFECT_FRAGMENT_GLSL }, {
    attributes: ['position', 'geomA', 'geomB', 'depth3', 'cut3', 'texRect'], uniforms: ['worldViewProjection', 'nearest', 'uHeight'], samplers: ['sheet'],
    needAlphaBlending: true,
  });
  material.setTexture('sheet', sheet);
  material.setFloat('nearest', sampling === 'nearest' ? 1 : 0);
  material.backFaceCulling = false;
  material.depthFunction = Constants.LEQUAL;
  material.disableDepthWrite = true;
  material.alphaMode = blend === 'add' ? Constants.ALPHA_ADD : Constants.ALPHA_COMBINE;
  return material;
}
